module.exports = __webpack_public_path__ + "media/images/icons/v2/arrow-narrow-right-b1f634e840a4765f82e8d3d0c8bbce19.svg";